import { render, staticRenderFns } from "./ArrayInput.vue?vue&type=template&id=c23a104e&scoped=true&"
import script from "./ArrayInput.vue?vue&type=script&lang=js&"
export * from "./ArrayInput.vue?vue&type=script&lang=js&"
import style0 from "./ArrayInput.vue?vue&type=style&index=0&id=c23a104e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23a104e",
  null
  
)

export default component.exports